import { render, staticRenderFns } from "./shift-file-upload.vue?vue&type=template&id=0f55e4e9&"
import script from "./shift-file-upload.vue?vue&type=script&lang=js&"
export * from "./shift-file-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "shift-file-upload.vue"
export default component.exports